<h3>Notifications</h3>
<p-button
  icon="fa-solid fa-trash"
  (click)="contentLayout.messageBusService.clearMessages()"
  styleClass="p-button-rounded p-button-danger p-button-text side-bar-close mr-7"
></p-button>

<p-divider></p-divider>
<p-messages
  [escape]="false"
  (valueChange)="contentLayout.messageBusService.setMessages($event)"
  [value]="contentLayout.messageBusService.getMessages()"
  styleClass="side-bar-message-container"
>
</p-messages>
